// /home/labdoo/zitech-nexus/frontend/src/pages/Dashboard.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { serviceAPI, adminAPI, adminTrainingAPI, getCurrentUser } from '../services/api';
import './Dashboard.css';

// SVG Icons
const Icons = {
  Total: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M8 2V6M16 2V6M3 10H21" />
    </svg>
  ),
  Pending: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  InProgress: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6V12L16 14" />
    </svg>
  ),
  Completed: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12L11 15L16 9" />
    </svg>
  ),
  Cancelled: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="8" y1="8" x2="16" y2="16" />
      <line x1="16" y1="8" x2="8" y2="16" />
    </svg>
  ),
  Users: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Enrollments: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" />
      <path d="M2 17L12 22L22 17" />
      <path d="M2 12L12 17L22 12" />
      <line x1="12" y1="12" x2="12" y2="7" />
    </svg>
  ),
  Progress: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Modules: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="8" y1="7" x2="16" y2="7" />
      <line x1="8" y1="12" x2="12" y2="12" />
    </svg>
  ),
  Plus: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <path d="M12 5V19M5 12H19" />
    </svg>
  ),
  ArrowRight: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  ),
  Projects: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="7" width="18" height="14" rx="2" />
      <path d="M8 7V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7" />
      <line x1="12" y1="12" x2="12" y2="16" />
      <line x1="10" y1="14" x2="14" y2="14" />
    </svg>
  ),
  Solutions: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" />
      <path d="M2 17L12 22L22 17" />
      <path d="M2 12L12 17L22 12" />
      <circle cx="12" cy="19" r="1.5" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="db-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  Empty: () => (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M8 2V6M16 2V6M3 10H21" />
    </svg>
  ),
  StatusDot: () => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor">
      <circle cx="4" cy="4" r="4" />
    </svg>
  ),
};

interface ServiceRequest {
  id: number;
  service_name: string;
  service_name_display?: string;
  status: string;
  created_at: string;
  project_details: string;
  user_name?: string;
  user_email?: string;
}

interface DashboardStats {
  total: number;
  pending: number;
  in_progress: number;
  completed: number;
  cancelled: number;
  total_users?: number;
}

interface TrainingStats {
  totalEnrollments: number;
  avgProgress: number;
  completedCount: number;
  inProgressCount: number;
  notStartedCount: number;
  totalStudents: number;
  totalModules: number;
}

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [requests, setRequests] = useState<ServiceRequest[]>([]);
  const [stats, setStats] = useState<DashboardStats>({
    total: 0,
    pending: 0,
    in_progress: 0,
    completed: 0,
    cancelled: 0,
  });
  const [trainingStats, setTrainingStats] = useState<TrainingStats>({
    totalEnrollments: 0,
    avgProgress: 0,
    completedCount: 0,
    inProgressCount: 0,
    notStartedCount: 0,
    totalStudents: 0,
    totalModules: 0,
  });
  const [user, setUser] = useState<any>(null);
  const [userRole, setUserRole] = useState<string>('user');

  useEffect(() => {
    const currentUser = getCurrentUser();
    setUser(currentUser);
    const role = currentUser?.role || 'user';
    setUserRole(role);
    fetchData();
  }, []);

  const isAdminOrSuperAdmin = (): boolean => {
    return userRole === 'superadmin' || userRole === 'admin';
  };

  const fetchData = async () => {
    try {
      let data;
      
      if (isAdminOrSuperAdmin()) {
        const response = await adminAPI.getAllRequests();
        data = response.data;
        
        const total = data.length;
        const pending = data.filter((r: ServiceRequest) => r.status === 'pending').length;
        const in_progress = data.filter((r: ServiceRequest) => r.status === 'in_progress' || r.status === 'in_review').length;
        const completed = data.filter((r: ServiceRequest) => r.status === 'completed').length;
        const cancelled = data.filter((r: ServiceRequest) => r.status === 'cancelled').length;
        
        const statsResponse = await adminAPI.getDashboardStats();
        
        setStats({ 
          total, 
          pending, 
          in_progress, 
          completed, 
          cancelled,
          total_users: statsResponse.data?.total_users || 0
        });
        
        await fetchTrainingStats();
        
      } else {
        const response = await serviceAPI.getMyServiceRequests();
        data = response.data;
        
        const total = data.length;
        const pending = data.filter((r: ServiceRequest) => r.status === 'pending').length;
        const in_progress = data.filter((r: ServiceRequest) => r.status === 'in_progress' || r.status === 'in_review').length;
        const completed = data.filter((r: ServiceRequest) => r.status === 'completed').length;
        const cancelled = data.filter((r: ServiceRequest) => r.status === 'cancelled').length;
        
        setStats({ total, pending, in_progress, completed, cancelled });
      }
      
      setRequests(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTrainingStats = async () => {
    try {
      const enrollmentsRes = await adminTrainingAPI.getAllEnrollments();
      const enrollments = enrollmentsRes.data;
      
      const modulesRes = await adminTrainingAPI.getAllModules();
      const modules = modulesRes.data;
      
      const totalEnrollments = enrollments.length;
      const totalProgress = enrollments.reduce((sum: number, e: any) => sum + (e.progress_percentage || 0), 0);
      const avgProgress = totalEnrollments > 0 ? Math.round(totalProgress / totalEnrollments) : 0;
      const completedCount = enrollments.filter((e: any) => e.status === 'completed').length;
      const inProgressCount = enrollments.filter((e: any) => e.status === 'in_progress').length;
      const notStartedCount = enrollments.filter((e: any) => e.status === 'not_started').length;
      const totalStudents = new Set(enrollments.map((e: any) => e.user)).size;
      const totalModules = modules.length;
      
      setTrainingStats({
        totalEnrollments,
        avgProgress,
        completedCount,
        inProgressCount,
        notStartedCount,
        totalStudents,
        totalModules
      });
      
    } catch (error) {
      console.error('Error fetching training stats:', error);
    }
  };

  const getStatusColor = (status: string): string => {
    const colors: Record<string, string> = {
      pending: '#f59e0b',
      in_review: '#0ea5e9',
      approved: '#10b981',
      in_progress: '#0ea5e9',
      completed: '#10b981',
      cancelled: '#ef4444',
    };
    return colors[status] || '#6b7280';
  };

  const getStatusBackground = (status: string): string => {
    const colors: Record<string, string> = {
      pending: '#fef3c7',
      in_review: '#dbeafe',
      approved: '#d1fae5',
      in_progress: '#dbeafe',
      completed: '#d1fae5',
      cancelled: '#fee2e2',
    };
    return colors[status] || '#f3f4f6';
  };

  const getStatusText = (status: string): string => {
    const texts: Record<string, string> = {
      pending: 'Pending',
      in_review: 'In Review',
      approved: 'Approved',
      in_progress: 'In Progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
    };
    return texts[status] || status;
  };

  const getServiceDisplayName = (request: ServiceRequest): string => {
    if (request.service_name_display) {
      return request.service_name_display;
    }
    if (request.service_name) {
      return request.service_name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }
    return 'Unknown Service';
  };

  const getStatIcon = (type: string) => {
    switch(type) {
      case 'total': return <Icons.Total />;
      case 'pending': return <Icons.Pending />;
      case 'in_progress': return <Icons.InProgress />;
      case 'completed': return <Icons.Completed />;
      case 'cancelled': return <Icons.Cancelled />;
      case 'users': return <Icons.Users />;
      case 'enrollments': return <Icons.Enrollments />;
      case 'progress': return <Icons.Progress />;
      case 'modules': return <Icons.Modules />;
      default: return null;
    }
  };

  const getStatColor = (type: string) => {
    switch(type) {
      case 'total': return 'db-stat-blue';
      case 'pending': return 'db-stat-yellow';
      case 'in_progress': return 'db-stat-cyan';
      case 'completed': return 'db-stat-green';
      case 'cancelled': return 'db-stat-red';
      case 'users': return 'db-stat-purple';
      case 'enrollments': return 'db-stat-blue';
      case 'progress': return 'db-stat-green';
      case 'modules': return 'db-stat-purple';
      default: return 'db-stat-blue';
    }
  };

  if (loading) {
    return (
      <div className="db-loading-container">
        <div className="db-spinner">
          <Icons.Spinner />
        </div>
        <p className="db-loading-text">Loading dashboard...</p>
      </div>
    );
  }

  const isAdminUser = userRole === 'superadmin' || userRole === 'admin';

  return (
    <div className="db-container">
      {/* Welcome Banner */}
      <div className="db-banner">
        <div className="db-banner-left">
          <h1 className="db-banner-title">
            Welcome back, {user?.full_name || user?.username}!
          </h1>
          <p className="db-banner-subtitle">
            {isAdminUser 
              ? 'Here\'s an overview of training programs and service requests.'
              : 'Here\'s what\'s happening with your service requests today.'}
          </p>
        </div>
        {!isAdminUser && (
          <button className="db-banner-btn" onClick={() => navigate('/dashboard/request-service')}>
            <Icons.Plus />
            New Request
          </button>
        )}
      </div>

      {/* Stats Grid */}
      {isAdminUser ? (
        <>
          <div className="db-stats-grid">
            <div className="db-stat-card">
              <div className={`db-stat-icon ${getStatColor('enrollments')}`}>
                {getStatIcon('enrollments')}
              </div>
              <div className="db-stat-content">
                <h3 className="db-stat-value">{trainingStats.totalEnrollments}</h3>
                <p className="db-stat-label">Total Enrollments</p>
              </div>
            </div>

            <div className="db-stat-card">
              <div className={`db-stat-icon ${getStatColor('users')}`}>
                {getStatIcon('users')}
              </div>
              <div className="db-stat-content">
                <h3 className="db-stat-value">{trainingStats.totalStudents}</h3>
                <p className="db-stat-label">Active Students</p>
              </div>
            </div>

            <div className="db-stat-card">
              <div className={`db-stat-icon ${getStatColor('progress')}`}>
                {getStatIcon('progress')}
              </div>
              <div className="db-stat-content">
                <h3 className="db-stat-value">{trainingStats.avgProgress}%</h3>
                <p className="db-stat-label">Average Progress</p>
              </div>
            </div>

            <div className="db-stat-card">
              <div className={`db-stat-icon ${getStatColor('modules')}`}>
                {getStatIcon('modules')}
              </div>
              <div className="db-stat-content">
                <h3 className="db-stat-value">{trainingStats.totalModules}</h3>
                <p className="db-stat-label">Active Modules</p>
              </div>
            </div>
          </div>

          {/* Training Status Cards */}
          <div className="db-stats-grid">
            <div className="db-stat-card">
              <div className={`db-stat-icon ${getStatColor('completed')}`}>
                {getStatIcon('completed')}
              </div>
              <div className="db-stat-content">
                <h3 className="db-stat-value">{trainingStats.completedCount}</h3>
                <p className="db-stat-label">Completed Trainings</p>
              </div>
            </div>

            <div className="db-stat-card">
              <div className={`db-stat-icon ${getStatColor('in_progress')}`}>
                {getStatIcon('in_progress')}
              </div>
              <div className="db-stat-content">
                <h3 className="db-stat-value">{trainingStats.inProgressCount}</h3>
                <p className="db-stat-label">In Progress</p>
              </div>
            </div>

            <div className="db-stat-card">
              <div className={`db-stat-icon ${getStatColor('pending')}`}>
                {getStatIcon('pending')}
              </div>
              <div className="db-stat-content">
                <h3 className="db-stat-value">{trainingStats.notStartedCount}</h3>
                <p className="db-stat-label">Not Started</p>
              </div>
            </div>

            <div className="db-stat-card">
              <div className={`db-stat-icon ${getStatColor('total')}`}>
                {getStatIcon('total')}
              </div>
              <div className="db-stat-content">
                <h3 className="db-stat-value">{stats.total}</h3>
                <p className="db-stat-label">Service Requests</p>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="db-stats-grid">
          <div className="db-stat-card">
            <div className={`db-stat-icon ${getStatColor('total')}`}>
              {getStatIcon('total')}
            </div>
            <div className="db-stat-content">
              <h3 className="db-stat-value">{stats.total}</h3>
              <p className="db-stat-label">Total Requests</p>
            </div>
          </div>

          <div className="db-stat-card">
            <div className={`db-stat-icon ${getStatColor('pending')}`}>
              {getStatIcon('pending')}
            </div>
            <div className="db-stat-content">
              <h3 className="db-stat-value">{stats.pending}</h3>
              <p className="db-stat-label">Pending</p>
            </div>
          </div>

          <div className="db-stat-card">
            <div className={`db-stat-icon ${getStatColor('in_progress')}`}>
              {getStatIcon('in_progress')}
            </div>
            <div className="db-stat-content">
              <h3 className="db-stat-value">{stats.in_progress}</h3>
              <p className="db-stat-label">In Progress</p>
            </div>
          </div>

          <div className="db-stat-card">
            <div className={`db-stat-icon ${getStatColor('completed')}`}>
              {getStatIcon('completed')}
            </div>
            <div className="db-stat-content">
              <h3 className="db-stat-value">{stats.completed}</h3>
              <p className="db-stat-label">Completed</p>
            </div>
          </div>
        </div>
      )}

      {/* Admin Quick Actions */}
      {isAdminUser && (
        <div className="db-card db-card-admin">
          <h3 className="db-card-title">Training Management Quick Links</h3>
          <div className="db-admin-grid">
            <div className="db-admin-card" onClick={() => navigate('/dashboard/admin/training/modules')}>
              <div className="db-admin-icon">
                <Icons.Modules />
              </div>
              <h4>Training Modules</h4>
              <p>Create and manage course modules</p>
            </div>
            <div className="db-admin-card" onClick={() => navigate('/dashboard/admin/student-progress')}>
              <div className="db-admin-icon">
                <Icons.Progress />
              </div>
              <h4>Student Progress</h4>
              <p>Track student learning progress</p>
            </div>
            <div className="db-admin-card" onClick={() => navigate('/dashboard/admin/portfolio/projects')}>
              <div className="db-admin-icon">
                <Icons.Projects />
              </div>
              <h4>Portfolio Projects</h4>
              <p>Manage portfolio projects</p>
            </div>
            <div className="db-admin-card" onClick={() => navigate('/dashboard/admin/portfolio/solutions')}>
              <div className="db-admin-icon">
                <Icons.Solutions />
              </div>
              <h4>Solutions</h4>
              <p>Manage solutions offerings</p>
            </div>
          </div>
        </div>
      )}

      {/* Recent Requests */}
      {isAdminUser && (
        <div className="db-card">
          <div className="db-card-header">
            <h3 className="db-card-title">Recent Service Requests</h3>
            {requests.length > 0 && (
              <button className="db-view-all" onClick={() => navigate('/dashboard/admin/requests')}>
                View All
                <Icons.ArrowRight />
              </button>
            )}
          </div>

          {requests.length === 0 ? (
            <div className="db-empty-state">
              <Icons.Empty />
              <h3 className="db-empty-title">No Service Requests Yet</h3>
              <p className="db-empty-text">There are no service requests in the system yet.</p>
            </div>
          ) : (
            <div className="db-table-wrapper">
              <table className="db-table">
                <thead>
                  <tr>
                    <th className="db-col-user">User</th>
                    <th className="db-col-service">Service</th>
                    <th className="db-col-status">Status</th>
                    <th className="db-col-date">Submitted</th>
                    <th className="db-col-actions">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.slice(0, 5).map((request) => (
                    <tr key={request.id} className="db-table-row">
                      <td className="db-col-user">
                        <span className="db-user-name">
                          <Icons.Users />
                          {request.user_name || request.user_email?.split('@')[0]}
                        </span>
                      </td>
                      <td className="db-col-service">
                        <span className="db-service-name">{getServiceDisplayName(request)}</span>
                      </td>
                      <td className="db-col-status">
                        <span 
                          className="db-status-badge"
                          style={{
                            background: getStatusBackground(request.status),
                            color: getStatusColor(request.status)
                          }}
                        >
                          <Icons.StatusDot />
                          {getStatusText(request.status)}
                        </span>
                      </td>
                      <td className="db-col-date">
                        <span className="db-date-text">
                          <Icons.Users />
                          {new Date(request.created_at).toLocaleDateString('en-US', { 
                            month: 'short', 
                            day: 'numeric', 
                            year: 'numeric' 
                          })}
                        </span>
                      </td>
                      <td className="db-col-actions">
                        <button 
                          className="db-view-btn"
                          onClick={() => navigate(`/dashboard/admin/requests/${request.id}`)}
                        >
                          View Details
                          <Icons.ArrowRight />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Dashboard;